import { useEffect, useState } from "react";
import { FPaquetesStyle } from "./styles";
import { catCiudad } from "../../../constant/catCiudad"
import {
  Grid,
  Button,
} from "@material-ui/core";
import TablaRegistro from "./TablaRegistro";
import BackDrop from "./../../../global/BackDrop";
import { useDispatch, useSelector } from "react-redux";
import { obtenerExtrasByIdPaqueteAction } from "../../../ducks/extrasDuck";
import AltaExtra from "./AltaExtra";
import HeaderModal from "../../../global/headerModal";
import ModalBase from "../../../global/ModalBase";

const FPaquetesExtras = (props) => {
  const { open = true, setOpen = () => { }, rowData = {} } = props;
  const dispatch = useDispatch();
  const extrasPaquetes = useSelector((state) => state.extras.array);
  const classes = FPaquetesStyle();
  const [isLoad, setIsload] = useState(false);
  useEffect(() => {
    setIsload(true);
    dispatch(obtenerExtrasByIdPaqueteAction(rowData.IdPaquete)).then(
      (Response) => {
        setIsload(false);
      }
    );
  }, [dispatch, rowData.IdPaquete]);
  const handleClose = () => {
    setOpen(!open);
  };
  return (
    <ModalBase classes={classes} open={open} onClose={handleClose}>
      <HeaderModal
        titulo={`Extras para el paqute ${rowData.Nombre}`}
        handleClose={handleClose}
      />
      <Grid container className={classes.containerSpacing}>
        <Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", margin: "10px" }}
        >
          <AltaExtra origen={{ IdCiudad: catCiudad.NO_APLICA }} IdPaquete={rowData.IdPaquete} Moneda={rowData.Moneda ? `${rowData.Moneda.Clave}` : ""} />
        </Grid>
        <Grid item xs={12}>
          <TablaRegistro
            rows={extrasPaquetes}
            idPaquete={rowData.IdPaquete}
            Moneda={rowData.Moneda ? `${rowData.Moneda.Clave}` : ""}
          />
        </Grid>
      </Grid>
      <Grid container className={classes.containerSpacing}>
        <Grid item xs={12} className={classes.modalBotonesCenter}>
          <Button
            onClick={handleClose}
            variant="contained"
            color="primary"
            className={classes.modalBoton}
          >
            Aplicar
          </Button>
        </Grid>
      </Grid>
      <BackDrop open={isLoad} />
    </ModalBase>
  );
};
export default FPaquetesExtras;
